var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Store from '@app/store';
import RouterFunctions from '@app/router/functions';
var prefetchOffset = 500;
var options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
};
/**
 * Preload page data for a given URL
 *
 * @param url Url to prefetch
 * @param delay Timeout before prefetch starts
 */
var prefetch = function (url, delay) {
    // setTimeout(() => {
    //     if (window.laravelDebug) {
    //         console.log('🚀 Prefetching ' + url)
    //     }
    //     Store.ACTIONS.loadPageData(url).then(data => {
    //         if (data) {
    //             Vue.set(Store.STATE.pageData[url], '__prefetched__', true)
    //         }   
    //     })
    // }, delay)
};
var intersectionHandler = function (entries, observer) { return __awaiter(void 0, void 0, void 0, function () {
    var intersectingEntries, linksToPrefetch, urls;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Wait for all routes to be loaded before starting to handle intersects
            return [4 /*yield*/, Store.STATE.routesLoaded
                // Only handle entries which are intersecting, immediately unobserve handled elements
            ];
            case 1:
                // Wait for all routes to be loaded before starting to handle intersects
                _a.sent();
                intersectingEntries = entries.filter(function (entry) { return entry.isIntersecting; });
                intersectingEntries.forEach(function (entry) { return observer.unobserve(entry.target); });
                linksToPrefetch = intersectingEntries
                    .map(function (el) { return new URL(el.target.href).pathname; })
                    .filter(function (url) { return !Store.STATE.pageData[url] && RouterFunctions.routeExists(url); });
                urls = Array.from(new Set(linksToPrefetch));
                urls.forEach(function (url, index) {
                    if ('requestIdleCallback' in window) {
                        window.requestIdleCallback(function () { return prefetch(url, 0); }, {
                            timeout: 5000
                        });
                    }
                    else {
                        prefetch(url, index * prefetchOffset);
                    }
                });
                return [2 /*return*/];
        }
    });
}); };
var observer;
if (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    observer = {
        observe: function (el) {
            // do nothing if IntersectionObserver is not supported
        }
    };
}
else {
    observer = new IntersectionObserver(intersectionHandler, options);
}
export default observer;
